export default {
      id: "file-invoice-euro-regular-usage",
      viewBox: "0 0 2000 2000",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#file-invoice-euro-regular",
      toString: function () {
        return this.url;
      }
    }